var _defs, _path, _path2, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListerBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 72 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#009a75;}.cls-3{fill:#00a980;}.cls-4{clip-path:url(#clip-path);}.cls-5{fill:#b8d8ff;}.cls-6{fill:#6fbaff;}.cls-7{fill:#282828;}.cls-8{fill:#98ceff;}.cls-9{clip-path:url(#clip-path-2);}.cls-10{fill:url(#linear-gradient);}.cls-11{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0 0.1)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.34,
    y: 13.07,
    width: 47.32,
    height: 40.68
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(0 0.1)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 37.41,
    y: 42.12,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 38.21,
    y1: 32.12,
    x2: 56.61,
    y2: 32.12,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 84.24)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#67c84d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#60c261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#4db395"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#2f9ae8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#2793ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#825af0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#9d56ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#e24ce2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#e44cd6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#e84cb5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#ea4ca2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#f74767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#f44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#ff6c28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#ffb200"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28.27,77.83,7.72,66A15.43,15.43,0,0,1,0,52.63V15.32A15.44,15.44,0,0,1,15.45-.1h41.1A15.44,15.44,0,0,1,72,15.32V52.63A15.43,15.43,0,0,1,64.28,66L43.73,77.83A15.47,15.47,0,0,1,28.27,77.83Z",
    transform: "translate(0 0.1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M41.15,71a10.93,10.93,0,0,1-10.3,0L11.56,60.63A10.41,10.41,0,0,1,6,51.46V16.72A10.59,10.59,0,0,1,16.71,6.26H55.29A10.59,10.59,0,0,1,66,16.72V51.46a10.41,10.41,0,0,1-5.56,9.17Z",
    transform: "translate(0 0.1)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M48.94,25.41a.35.35,0,0,1-.35-.35l-.06-8a3.63,3.63,0,0,0-3.06-3.19,3.28,3.28,0,0,0-2.48,1,4,4,0,0,0-1.19,3l-.09,5.91a.35.35,0,0,1-.35.34h0a.35.35,0,0,1-.35-.35l.09-5.89a4.62,4.62,0,0,1,1.4-3.55,4,4,0,0,1,3-1.17,4.36,4.36,0,0,1,3.71,3.81v0l.06,8.07a.35.35,0,0,1-.35.35Z",
    transform: "translate(0 0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.94,25.56a.5.5,0,0,1-.5-.49l-.06-8a3.48,3.48,0,0,0-2.93-3,3.1,3.1,0,0,0-2.35.93A3.81,3.81,0,0,0,42,17.83l-.09,5.92a.5.5,0,0,1-.5.49.48.48,0,0,1-.36-.15.5.5,0,0,1-.14-.35L41,17.85a4.74,4.74,0,0,1,1.45-3.66A4.08,4.08,0,0,1,45.53,13a4.48,4.48,0,0,1,3.84,3.93.17.17,0,0,1,0,.07l.06,8.07a.52.52,0,0,1-.14.35.45.45,0,0,1-.21.12v0ZM45.25,13.67h.23A3.8,3.8,0,0,1,48.68,17l.06,8.06a.2.2,0,0,0,.17.2h0a.21.21,0,0,0,.2-.2L49.08,17a4.2,4.2,0,0,0-3.57-3.71,3.77,3.77,0,0,0-2.9,1.13,4.45,4.45,0,0,0-1.36,3.43l-.09,5.9a.18.18,0,0,0,.06.14.2.2,0,0,0,.34-.13l.09-5.91a4.09,4.09,0,0,1,1.24-3.15A3.48,3.48,0,0,1,45.25,13.67Z",
    transform: "translate(0 0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M57,22.63Q58.29,36.34,59.6,50L54,53.67q-.87-14.52-1.75-29h0C52.35,24.58,53.91,23.91,57,22.63Z",
    transform: "translate(0 0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M57,22.63c-3.07,1.28-4.63,1.95-4.7,2h0L31.05,20.88Z",
    transform: "translate(0 0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M57,22.63,31.05,20.88l5.35-1.61Z",
    transform: "translate(0 0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M52.28,24.63q.87,14.52,1.75,29L28,48.41l3.07-27.53Z",
    transform: "translate(0 0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.19,53.86l-.19,0L27.82,48.53V48.4l3.09-27.7.16,0,21.23,3.75.11,0v.12q.81,13.52,1.63,27Zm-26-5.57,25.72,5.2-.11-1.84L52.14,24.76l-21-3.7Z",
    transform: "translate(0 0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.12,53.8,54,53.55,59.44,50,56.85,22.84c-2.13.9-4.34,1.83-4.48,1.91l0,0h0v-.15l-.09-.11c.06-.06.41-.22,4.73-2l.19-.08,2.65,27.71Z",
    transform: "translate(0 0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.28,24.78v-.3l.17-.07.11.28C52.33,24.78,52.31,24.78,52.28,24.78Z",
    transform: "translate(0 0.1)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "56.96 22.87 36.41 19.52 31.09 21.12 31.01 20.84 36.38 19.22 36.42 19.22 57.01 22.58 56.96 22.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M46.5,26.33a.35.35,0,0,1-.35-.35l-.06-8A3.63,3.63,0,0,0,43,14.75a3.28,3.28,0,0,0-2.48,1,4,4,0,0,0-1.19,3l-.09,5.91a.35.35,0,0,1-.35.34h0a.35.35,0,0,1-.35-.35l.09-5.89a4.62,4.62,0,0,1,1.4-3.55,3.94,3.94,0,0,1,3-1.16,4.34,4.34,0,0,1,3.71,3.8v.05L46.85,26a.35.35,0,0,1-.35.35Z",
    transform: "translate(0 0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5,26.48A.5.5,0,0,1,46,26l-.06-8a3.49,3.49,0,0,0-2.93-3,3.11,3.11,0,0,0-2.35.93,3.81,3.81,0,0,0-1.15,2.92l-.09,5.92a.5.5,0,0,1-.5.49.48.48,0,0,1-.36-.15.5.5,0,0,1-.14-.35l.09-5.89A4.74,4.74,0,0,1,40,15.11a4.08,4.08,0,0,1,3.13-1.2,4.48,4.48,0,0,1,3.84,3.93.2.2,0,0,1,0,.07L47,26a.52.52,0,0,1-.14.35.56.56,0,0,1-.25.14H46.5ZM42.81,14.59H43a3.8,3.8,0,0,1,3.2,3.32L46.3,26a.2.2,0,0,0,.17.2h0a.18.18,0,0,0,.14-.06A.2.2,0,0,0,46.7,26l-.06-8.07a4.18,4.18,0,0,0-3.57-3.7,3.76,3.76,0,0,0-2.9,1.12,4.45,4.45,0,0,0-1.36,3.43l-.09,5.9a.17.17,0,0,0,.06.14.2.2,0,0,0,.34-.13l.09-5.91a4.12,4.12,0,0,1,1.24-3.15A3.48,3.48,0,0,1,42.81,14.59Z",
    transform: "translate(0 0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M33.36,29.16a.33.33,0,0,1-.35-.3l-.06-7a3.4,3.4,0,0,0-3.06-2.76,3.57,3.57,0,0,0-2.48.84,3.22,3.22,0,0,0-1.19,2.64l-.09,5.12a.33.33,0,0,1-.35.3h0a.33.33,0,0,1-.35-.31l.09-5.11a3.78,3.78,0,0,1,1.4-3.08,4.29,4.29,0,0,1,3-1,4.08,4.08,0,0,1,3.71,3.3v0l.06,7a.33.33,0,0,1-.35.3Z",
    transform: "translate(0 0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.36,29.31h0a.48.48,0,0,1-.5-.45l-.06-7a3.26,3.26,0,0,0-2.92-2.61,3.42,3.42,0,0,0-2.37.8,3.06,3.06,0,0,0-1.14,2.52l-.09,5.13a.48.48,0,0,1-.5.45A.56.56,0,0,1,25.4,28a.47.47,0,0,1-.12-.31l.09-5.11a3.86,3.86,0,0,1,1.46-3.19,4.41,4.41,0,0,1,3.12-1,4.21,4.21,0,0,1,3.84,3.43.13.13,0,0,1,0,.06l.06,7a.4.4,0,0,1-.13.31.5.5,0,0,1-.37.15ZM29.68,19h.22a3.57,3.57,0,0,1,3.2,2.89l.06,7c0,.13.25.2.36.09a.13.13,0,0,0,0-.09l-.06-7a3.93,3.93,0,0,0-3.57-3.19,4.15,4.15,0,0,0-2.91,1,3.61,3.61,0,0,0-1.35,3l-.09,5.11a.13.13,0,0,0,0,.1c.11.1.36,0,.36-.09l.09-5.13a3.34,3.34,0,0,1,1.25-2.75A3.75,3.75,0,0,1,29.68,19Z",
    transform: "translate(0 0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M36.7,28.49c.08,0,1.64-.63,4.7-1.74Q42.72,38.63,44,50.53l-5.56,3.14q-.89-12.58-1.76-25.18Z",
    transform: "translate(0 0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M41.4,26.75,15.47,25.23l5.35-1.39Z",
    transform: "translate(0 0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M15.47,25.23,41.4,26.75c-3.06,1.11-4.62,1.69-4.7,1.74h0Z",
    transform: "translate(0 0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M36.7,28.49q.88,12.59,1.76,25.18L12.4,49.11l3.07-23.88Z",
    transform: "translate(0 0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.62,53.85l-.19,0L12.24,49.23l0-.14,3.08-24,7.84,1.2,13.54,2.07.12,0v.12ZM12.57,49l25.72,4.5L36.56,28.61,23.13,26.56,15.6,25.4Z",
    transform: "translate(0 0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.53,53.8l-.15-.26,5.48-3.1L41.28,27c-2.23.81-4.36,1.59-4.5,1.66l0,0h0v-.15l-.08-.12c.07-.05.75-.3,4.73-1.75l.18-.07,0,.19,2.63,23.88Z",
    transform: "translate(0 0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7,28.63v-.3l.18-.06.1.29A1,1,0,0,1,36.7,28.63Z",
    transform: "translate(0 0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.38,26.89,20.83,24l-2.93.76-2.39.63-.07-.29,2.38-.63,3-.77h.06L41.42,26.6Z",
    transform: "translate(0 0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M30.92,30a.33.33,0,0,1-.35-.3l-.06-7a3.4,3.4,0,0,0-3.06-2.76,3.57,3.57,0,0,0-2.48.84,3.22,3.22,0,0,0-1.19,2.63l-.09,5.13a.33.33,0,0,1-.35.3h0a.33.33,0,0,1-.35-.31l.09-5.11a3.78,3.78,0,0,1,1.4-3.08,4.29,4.29,0,0,1,3-1,4.08,4.08,0,0,1,3.71,3.3v0l.06,7a.33.33,0,0,1-.35.3Z",
    transform: "translate(0 0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.92,30.11h0a.48.48,0,0,1-.5-.45l-.06-7a3.26,3.26,0,0,0-2.92-2.61,3.4,3.4,0,0,0-2.37.8,3.06,3.06,0,0,0-1.14,2.52l-.09,5.13a.48.48,0,0,1-.5.45.53.53,0,0,1-.38-.16.42.42,0,0,1-.12-.3l.09-5.11a3.86,3.86,0,0,1,1.46-3.19,4.41,4.41,0,0,1,3.12-1,4.2,4.2,0,0,1,3.84,3.42.17.17,0,0,1,0,.07l.06,7a.4.4,0,0,1-.13.31.5.5,0,0,1-.37.15ZM27.24,19.76h.22a3.57,3.57,0,0,1,3.2,2.89l.06,7c0,.13.25.19.36.09a.13.13,0,0,0,0-.09l-.06-7a3.91,3.91,0,0,0-3.57-3.19,4.15,4.15,0,0,0-2.91,1,3.6,3.6,0,0,0-1.35,3l-.09,5.11a.13.13,0,0,0,0,.1c.11.1.36,0,.36-.09l.09-5.13a3.34,3.34,0,0,1,1.25-2.75A3.75,3.75,0,0,1,27.24,19.76Z",
    transform: "translate(0 0.1)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M56.6,50.81a2.43,2.43,0,0,0-.78-1.72l-5.33-4.88h0a2.54,2.54,0,0,0-3.57.17l-4.51,4.84a2.08,2.08,0,0,0-1.3-.16A2.1,2.1,0,0,0,40,49.7L38.77,51a2.1,2.1,0,0,0,.11,3l4.63,4.22a2.23,2.23,0,0,0,1.3.54,2.2,2.2,0,0,0,1.36-.34l2,1.82a2,2,0,0,0,1.3.49h.09a2,2,0,0,0,1.33-.62l1.44-1.54a2,2,0,0,0,.25-2.31L56,52.58A2.42,2.42,0,0,0,56.6,50.81Z",
    transform: "translate(0 0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M50.52,51.14a.36.36,0,0,1-.09.24L45.5,56.52l-.31.31a.36.36,0,0,1-.23.08.35.35,0,0,1-.22-.08l-4.6-4.18a.37.37,0,0,1-.07-.2.27.27,0,0,1,.08-.19l1.15-1.32a.29.29,0,0,1,.22-.09.31.31,0,0,1,.22.09l3.12,2.82,3.82-4a.39.39,0,0,1,.25-.1.36.36,0,0,1,.25.1l1.24,1.14a.3.3,0,0,1,.1.17h0Z",
    transform: "translate(0 0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M51.78,52.48A2.14,2.14,0,0,0,52.4,51h0a2.18,2.18,0,0,0-.7-1.46l-1.28-1.19h0a2.11,2.11,0,0,0-1.55-.56,2.19,2.19,0,0,0-1.5.68l-2.6,2.74-.92-.85,4.4-4.76a.73.73,0,0,1,.5-.21.8.8,0,0,1,.52.16l5.31,4.85a.57.57,0,0,1,.16.22.59.59,0,0,1,.07.26.84.84,0,0,1,0,.27.79.79,0,0,1-.14.23l-4.54,4.93.93.83a.11.11,0,0,1,0,.08.11.11,0,0,1,0,.07l-1.43,1.55a.17.17,0,0,1-.1,0,.09.09,0,0,1-.08,0l-1.95-1.78Z",
    transform: "translate(0 0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M48.8,43.56a2.53,2.53,0,0,1,1.69.65h0l5.33,4.88A2.49,2.49,0,0,1,56,52.58L52.6,56.22a2,2,0,0,1-.25,2.31l-1.44,1.54a2,2,0,0,1-1.33.62h-.1a2,2,0,0,1-1.29-.49l-2-1.82a2.2,2.2,0,0,1-1.19.35,2.27,2.27,0,0,1-1.47-.55L38.88,54a2.1,2.1,0,0,1-.11-3L40,49.7a2.07,2.07,0,0,1,1.21-.65l.33,0a2.15,2.15,0,0,1,.9.2l4.51-4.84a2.54,2.54,0,0,1,1.75-.82h.13m0-.6h-.16a3.14,3.14,0,0,0-2.16,1l-4.24,4.55a2.92,2.92,0,0,0-.73-.1,2.69,2.69,0,0,0-1.08.23,2.74,2.74,0,0,0-.9.64l-1.2,1.29a2.7,2.7,0,0,0,.14,3.82h0l4.63,4.21h0a2.74,2.74,0,0,0,1.41.68,2.84,2.84,0,0,0,1.55-.19l1.71,1.54h0a2.53,2.53,0,0,0,1.68.64h.13a2.52,2.52,0,0,0,1.74-.81l1.43-1.54a2.59,2.59,0,0,0,.63-1.23,2.55,2.55,0,0,0-.1-1.37L56.4,53a3.11,3.11,0,0,0-.17-4.34h0l-5.33-4.89h0A3.12,3.12,0,0,0,48.8,43Z",
    transform: "translate(0 0.1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListerBadge);
export default __webpack_public_path__ + "static/media/listerBadge.edf275f52a6e4d9d169437332c4761b4.svg";
export { ForwardRef as ReactComponent };